// Rhythm Command Center — weekly review & planning helpers
import { autopullValues, pillarSummary, overallIndex, pillars, measureById } from "@/lib/pillars";

export const RHYTHM_ACCENT = "#1f5a49";

function pad(n) { return String(n).padStart(2, "0"); }
export function isoLocal(d) { return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; }

// Monday (ISO) of the week containing dateStr.
export function weekKey(dateStr) {
  const x = new Date(dateStr + "T12:00:00");
  const day = (x.getDay() + 6) % 7; // 0 = Monday
  x.setDate(x.getDate() - day);
  return isoLocal(x);
}
export function shiftWeek(mondayStr, weeks) {
  const d = new Date(mondayStr + "T12:00:00");
  d.setDate(d.getDate() + weeks * 7);
  return isoLocal(d);
}
export function weekRangeLabel(mondayStr) {
  const start = new Date(mondayStr + "T12:00:00");
  const end = new Date(start); end.setDate(start.getDate() + 6);
  const opts = { month: "short", day: "numeric" };
  const sameMonth = start.getMonth() === end.getMonth();
  const s = start.toLocaleDateString("en-US", opts);
  const e = end.toLocaleDateString("en-US", sameMonth ? { day: "numeric" } : opts);
  return `${s} – ${e}, ${end.getFullYear()}`;
}

// The five life pillars mapped for review/planning domains.
export const domains = pillars.map((p) => ({ id: p.id, name: p.name, short: p.short, color: p.color, icon: p.icon }));

// Build the whole-life scoreboard from live center data + saved pillar values.
export function buildScoreboard(fin, life, wellness, pillarStore) {
  const auto = autopullValues(fin, life, wellness);
  const manual = pillarStore?.measures || {};
  const currentMap = {};
  Object.keys(measureById).forEach((id) => {
    const mv = manual[id]?.value;
    if (mv != null && mv !== "") currentMap[id] = mv;
    else if (auto[id]) currentMap[id] = auto[id].value;
  });
  const perPillar = pillars.map((p) => ({ ...p, ...pillarSummary(p.id, currentMap) }));
  return { index: overallIndex(currentMap), pillars: perPillar };
}

export const emptyReview = () => ({
  ratings: { overall: 7, faith: 7, health: 7, work: 7, wealth: 7, legacy: 7 },
  wins: ["", "", ""],
  gratitude: ["", "", ""],
  lessons: ["", ""],
  big3Review: [],
  openLoops: "",
  notes: "",
});

export const emptyPlan = () => ({
  theme: "",
  scripture: "",
  big3: [{ text: "", done: false }, { text: "", done: false }, { text: "", done: false }],
  domainFocus: { faith: "", health: "", work: "", wealth: "", legacy: "" },
  obstacles: [{ risk: "", plan: "" }],
  timeBlocks: ["", "", ""],
  rest: "",
});
